import {Component, Input} from '@angular/core';
import {CartService, LineItem} from '../../shopping-cart/cart.service';
import {Cart} from '../../shopping-cart/Cart';
import {CurrencyPipe, DatePipe, NgForOf, NgIf} from '@angular/common';
import {PurchaseTitleComponent} from '../purchase-title/purchase-title.component';
import {CartStatusBadgeComponent} from '../cart-status-badge/cart-status-badge.component';

@Component({
  selector: 'app-past-order',
  templateUrl: './past-order.component.html',
  styleUrls: ['./past-order.component.scss'],
  standalone: true,
  imports: [
    DatePipe,
    NgForOf,
    NgIf,
    PurchaseTitleComponent,
    CurrencyPipe,
    CartStatusBadgeComponent
  ]
})
export class PastOrderComponent {

  #cart: Cart;
  total: number;
  @Input()
  items: ReadonlyArray<LineItem> = [];

  constructor(private readonly cartService: CartService) {
  }

  @Input()
  set cart(given: Cart) {
    this.#cart = given;
    this.total = this.cartService.calcTotals(this.cart).total;
  }

  get cart(): Cart {
    return this.#cart;
  }

}
